module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-half"
  }, [_c('article', {
    staticClass: "message"
  }, [_c('div', {
    staticClass: "message-header"
  }, [_c('p', [_vm._v(_vm._s(_vm.index + 1) + "조 (" + _vm._s(_vm.group.length) + "명)"), _c('b', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }]
  }, [_vm._v(" (성적 총합 " + _vm._s(_vm.sum.toFixed(2)) + "점)")])])]), _c('div', {
    staticClass: "message-body has-text-centered"
  }, [_c('transition-group', {
    attrs: {
      "name": "result-student"
    }
  }, _vm._l((_vm.group), function(student) {
    return _c('div', {
      key: student.name,
      staticClass: "tag is-large"
    }, [_vm._v(_vm._s(student.name)), _c('b', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.show),
        expression: "show"
      }]
    }, [_vm._v(" (" + _vm._s(student.grade) + "점)")])])
  }))], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-267c9a73"}!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/Group.vue
// module id = 328
// module chunks = 0